import loadable from 'components/dynamic-import';

export { PaymentFooter } from './components/payment-footer';
export const Checkout = loadable(() => import('./CheckoutDialog'));
export const PaymentResultPage = loadable(() => import('./PaymentReturn'));
export const PaymentReturnPage = loadable(() => import('./ConnectedPaymentReturn'));
